import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_BASE } from '../../core/constants';
import { HttpUtils } from '../../shared/http-utils';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class BlujayService {

  constructor(private http: HttpClient) {
  }

  public verifyCredentials(blujayUrl: string, username: string, apiToken: string): Observable<boolean> {
    const headers = HttpUtils.createHeaders();
    return this.http.post<boolean>(
      `${URL_BASE}/api/blujay/verify/carrier`,
      {
        blujay_url: blujayUrl,
        credentials: { username, apiToken }
      },
      { headers });
  }
}
